

import tokens from '@/plugins/mask/tokens'
import mask from '@/plugins/mask/directive'


export default {
    install: (Vue) => {
    // List of tokens
        const masks = {
            N: {
                pattern: /[a-zA-Z0-9 ñÑäëïöüÄËÏÖÜ]/,
                transform: v => v.toLocaleUpperCase(),
            },
            n: {
                pattern: /[a-zA-Z0-9 ñÑäëïöüÄËÏÖÜ]/,
                transform: v => v.toLocaleLowerCase(),
            },
            c: {
                pattern: /[0-9-]/,
            },
            d: {
                pattern: /[a-zA-Z0-9-.]/,
            },
        }

    // Attach custom masks on default masks
        for (const token in masks) {
            tokens[token] = masks[token]
        }
        Vue.directive('mask', mask)
    },
}
